import { useContext, useRef } from "react";
import { formatCurrency } from "../../../utils/FormatUtils";
import { TranslationService } from "../../../services/TranslationService";
import TableContext from "../../task/TableContext";
import { ConsolidatedClientTableContextValues } from "../providers/ConsolidatedClientTableProvider";
import CompanyService from "../../../services/CompanyService";
import TooltipComponent from "../../shared/TooltipComponent";
import ClientTooltip, {
  TooltipBarClient
} from "../../client/components/ClientTooltipConsolidated";
import { useHistory } from "react-router-dom";
import { endpointRequest } from "../../../utils/RequestUtils";
import ClientService from "../../../services/ClientService";
import Loading from "../../shared/components/Loading";
import { renderToStaticMarkup } from "react-dom/server";

const ConsolidatedClientTableItem = (props: any) => {
  const { max } = useContext(
    TableContext
  ) as ConsolidatedClientTableContextValues;
  const aging = useRef<string[]>([]);
  const history = useHistory();

  const setTooltipBarData = async () => {
    const tooltipElement = document.getElementsByClassName(
      "tooltip-aging-" + props.data.PersonId
    )[0];

    if (aging.current[props.data.PersonId]) {
      tooltipElement.outerHTML = aging.current[props.data.PersonId];
      return;
    }

    endpointRequest(
      () => ClientService.getAging(props.data.PersonId),
      (x) => {
        if (!tooltipElement) {
          return;
        }
        aging.current[props.data.PersonId] = renderToStaticMarkup(
          <TooltipBarClient
            ageing={x}
            amount={props.data.amount ?? 0}
            overdueAmount={props.data.overdueAmount ?? 0}
            noDueAmount={props.data.noDueAmount ?? 0}
          ></TooltipBarClient>
        );
        tooltipElement.outerHTML = aging.current[props.data.PersonId];
      }
    );
  };

  const handleRowClick = () => {
    const key = encodeURIComponent(
      props.data.personKey || props.data.Name || ""
    );
    history.push(
      `/${TranslationService.currentLanguage}/consolidated/client/details?key=${key}`
    );
  };

  const overdueBar =
    ((props.data?.overdueAmount
      ? props.data.overdueAmount < 0
        ? 0
        : props.data.overdueAmount
      : 0) *
      100) /
    max;
  const noDueAmountBar = (props.data.noDueAmount * 100) / max;

  return (
    <tr role="button" onClick={handleRowClick} style={{ cursor: "pointer" }}>
      <td>
        <span>
          <TooltipComponent
            hideDelay={1000}
            title={<ClientTooltip client={props.data} />}
          >
            {props.data.Name
              ? props.data.Name
              : (props.data.personKey ?? "sin nombre")}
          </TooltipComponent>
        </span>
      </td>
      <td className="text-end">
        <span className="w-md">{props.data.count ?? 0}</span>
      </td>
      <td className="text-end">
        <span className="w-md">
          {formatCurrency(
            props.data.amount ?? 0,
            CompanyService.getDefaultCurrencyId()
          )}
        </span>
      </td>
      <td className="bar-progress">
        <TooltipComponent
          title={
            <div className={"tooltip-aging-" + props.data.PersonId}>
              <Loading></Loading>
            </div>
          }
          onInserted={() => setTooltipBarData()}
        >
          <div className="bar">
            {(props.data.overdueAmount > 0 || props.data.noDueAmount > 0) && (
              <>
                <div
                  className="expired"
                  style={{ width: overdueBar + "%" }}
                ></div>
                <div
                  className="not-expired"
                  style={{ width: noDueAmountBar + "%" }}
                ></div>
              </>
            )}
          </div>
        </TooltipComponent>
      </td>
    </tr>
  );
};

export default ConsolidatedClientTableItem;
